
var initializated = false; // in TWIPS

function loadPLantilla(html) {
    var encoded = btoa(unescape(encodeURIComponent(html))); // btoa base-64-encodes s
    TXTextControl.appendDocument(TXTextControl.streamType.HTMLFormat, encoded);
}

function getHtmlDocument() {

   console.log("getHtmlDocument");
    // TXTextControl.addEventListener("textControlChanged", function() {
    return new Promise(resolve => {
        TXTextControl.saveDocument(TXTextControl.streamType.HTMLFormat, function(e) {
            var html = e.data.replace('<?xml version="1.0" ?>', '');
            html = html.replace('\r\n<head>\r\n<meta content=\"TX29_HTM 29.0.900.500\" name=\"GENERATOR\" />\r\n<title> - This document has been created with TX Text Control Trial Version 29.0 Server</title>\r\n</head>\r\n', '');
            resolve(html);
        });
    });
}


function getPdfDocument() {
    return new Promise(resolve => {
        TXTextControl.saveDocument(TXTextControl.streamType.AdobePDF, function(e) {
            resolve(e.data);
        });
    });
}

function remove() {
}

function loadData(html) {



  if (!initializated) {
    TXTextControl.init({
      containerID: "txDocumentEditor",
      webSocketURL: "ws://localhost:8080/api/TXWebSocket"
    });
  } else {
    TXTextControl.refreshLayout();
  }


    html = html.replace('<?xml version="1.0" ?>', '');
    TXTextControl.addEventListener("textControlLoaded", function() {

       initializated = true;
      TXTextControl.clipboardMode = TXTextControl.ClipboardMode.Client;
      TXTextControl.setIsSpellCheckingEnabled(true);
        var encoded = btoa(unescape(encodeURIComponent(html))); // btoa base-64-encodes s
        TXTextControl.loadDocument(TXTextControl.streamType.HTMLFormat, encoded);
    });
}

function change(func) {
    TXTextControl.addEventListener("textControlChanged", function() {
        TXTextControl.getText((text) => {

        });
    });
}
